import { type MouseEvent } from 'react';

type ClientPosition = Pick<MouseEvent, 'clientY' | 'clientX'>;

export const calculateMousePositions = (
  { clientY, clientX }: ClientPosition,
  target: EventTarget & Element,
) => {
  const { top, left } = target.getBoundingClientRect();
  return {
    absolute: {
      x: clientX,
      y: clientY,
    },
    relative: {
      x: clientX - left,
      y: clientY - top,
    },
  };
};
